import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
    AppThemeColor,
	BreakpointWidth,
} from '@app/enumerations';
// Import props.
import {
	ComparativeDataHeaderProps,
} from '@app/props';
// Import services.
import {
	StylesService
} from '@app/services';
// Import types.
import {
	TFontSize,
} from '@app/types';

const useStyles = makeStyles((theme: Theme) => {

	const getFontSize = (fontSize: TFontSize | undefined, isMobile: boolean): string | number | undefined =>
		StylesService.getInstance().getThemeFontSize(theme, fontSize ?? 'sm', isMobile);

	const getFontColor = (color: AppThemeColor | undefined): string =>
		StylesService.getInstance().getThemeColor(theme, color ?? AppThemeColor.INFO);

	return createStyles({
		comparativeDataHeader_container: {
			display: 'flex',
			justifyContent: 'space-between',
			background: theme.palette.background.default,
			padding: (props: ComparativeDataHeaderProps) => {
				return theme.spacing(
					props.paddingProps?.top !== undefined ? props.paddingProps.top : 1,
					props.paddingProps?.right ?? 0,
					props.paddingProps?.bottom !== undefined ? props.paddingProps.bottom : 1,
					props.paddingProps?.left ?? 0)
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				minHeight: (props: ComparativeDataHeaderProps) => getFontSize(props.titleFontSize, false),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				minHeight: (props: ComparativeDataHeaderProps) => getFontSize(props.titleFontSize, true),
			},
		},
		comparativeDataHeader_headerLeft: {
			display: 'flex',
		},
		comparativeDataHeader_headerRight: {
			display: 'flex',
		},
		comparativeDataHeader_titleIconContainer: {
			marginRight: (props: ComparativeDataHeaderProps) => theme.spacing(props.spacingBetweenIconAndTitle ?? 1),
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: (props: ComparativeDataHeaderProps) => getFontSize(props.titleFontSize, false),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: (props: ComparativeDataHeaderProps) => getFontSize(props.titleFontSize, true),
			},
		},
		comparativeDataHeader_titleIcon: {
			fontSize: '150%',
		},
		comparativeDataHeader_titleIconColor: {
			color: (props: ComparativeDataHeaderProps) => getFontColor(props.titleColor),
		},
		comparativeDataHeader_title: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		comparativeDataHeader_titleFont: {
			fontStyle: (props: ComparativeDataHeaderProps) => props.titleFontStyle ?? 'normal',
			fontWeight: (props: ComparativeDataHeaderProps) => props.titleFontWeight ?? theme.typography.fontWeightBold,
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: (props: ComparativeDataHeaderProps) => getFontSize(props.titleFontSize, false),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: (props: ComparativeDataHeaderProps) => getFontSize(props.titleFontSize, true),
			},
		},
		comparativeDataHeader_titleColor: {
			color: (props: ComparativeDataHeaderProps) => getFontColor(props.titleColor),
		},
		comparativeDataHeader_titlePostFix: {
			margin: theme.spacing(0, 2),
		},
		comparativeDataHeader_titlePostFixFont: {
			fontStyle: (props: ComparativeDataHeaderProps) => props.titlePostFixFontStyle ?? 'normal',
			fontWeight: (props: ComparativeDataHeaderProps) => props.titlePostFixFontWeight ?? theme.typography.fontWeightBold,
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: (props: ComparativeDataHeaderProps) => getFontSize(props.titlePostFixFontSize, false),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: (props: ComparativeDataHeaderProps) => getFontSize(props.titlePostFixFontSize, true),
			},
		},
		comparativeDataHeader_titlePostFixColor: {
			color: (props: ComparativeDataHeaderProps) => getFontColor(props.titlePostFixColor),
		},
		comparativeDataHeader_iconButtons: {
			display: 'flex',
		},
		comparativeDataHeader_iconButton: {
			textTransform: 'none',
			color: theme.palette.info.main,
			fontSize: theme.spacing(2),
		},
		comparativeDataHeader_iconButtonEnd: {
			marginLeft: theme.spacing(0),
		},
		comparativeDataHeader_iconButtonIcon: {
			color: theme.palette.info.main,
			fontSize: `${theme.spacing(3.75)} !important`,
		},
	});
});

export default useStyles;
